import React from 'react';
import { ImpersonateStudent } from '@/components/staffer/ImpersonateStudent';
import useGradesTableStore from '../../store/useGradesTableStore';
import styles from '../styles.module.scss';
import StudentGradeCell from './StudentGradeCell';
import { IStudent } from '../../types';

interface StudentRowProps {
  student: IStudent
}

const StudentRow = ({ student }: StudentRowProps) => {
  const assignments = useGradesTableStore(state => state.assignments);
  const submissions = useGradesTableStore(state => state.submissions);
  const programId = useGradesTableStore(state => state.programId);
  const stafferId = useGradesTableStore(state => state.stafferId);
  const isImpersonating = useGradesTableStore(state => state.isImpersonating);

  return (
    <tr key={student.id} className={styles.studentRow}>
      <td className={styles.studentNameCell}>
        {student.first_name} {student.last_name}
        <span className="tw-float-right tw-pr-2 -tw-mt-1">
          <ImpersonateStudent
            buttonClass={`${styles.impersonateButton}`}
            enabled={!isImpersonating}
            programId={programId}
            stafferId={stafferId}
            student={{ ...student, name: `${student.first_name} ${student.last_name}` }}
          />
        </span>
      </td>

      {assignments.map((assignment, i) => {
        const submission = submissions.find(s => (s.user_id === student.id && s.assignment_id === assignment.id));

        return (
          <StudentGradeCell
            assignment={assignment}
            lastCell={i === assignments.length - 1}
            student={student}
            submission={submission}
          />
        );
      })}
    </tr>
  );
};

export default StudentRow;
